export default "__VITE_ASSET__Dwau_gnl__"